import { createStore } from 'vuex'

export default createStore({
  state: {
    grid: 6
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
